import CellLink from '@/components/GokuDataGrid/CellLink'
import { ResellerCandidateContact } from '@/modules/Reseller/types'
import { generatePathDatacentral, paths } from '@/utils/path'
import { TFunction } from 'i18next'
import { NavigateFunction } from 'react-router-dom'
import { Button, Tooltip, Typogaphy } from 'vnetwork-ui'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'

export const resellerCandidateColumns = (
    t: TFunction,
    navigate: NavigateFunction
): GridColDefVNW<ResellerCandidateContact>[] => [
    {
        field: 'contact_name',
        headerName: t('contact_name'),
        sortable: false,
        renderCell: ({ row }) => (
            <Tooltip title={row?.contact_email || ''}>
                <Typogaphy>{row?.contact_name || '-'}</Typogaphy>
            </Tooltip>
        ),
        width: 220,
    },
    {
        field: 'contact_email',
        headerName: t('email'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.contact_email || '-'}</Typogaphy>
        ),
        width: 220,
    },
    {
        field: 'contact_phone',
        headerName: t('phone'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.contact_phone || '-'}</Typogaphy>
        ),
        width: 150,
    },
    {
        field: 'linked_contact',
        headerName: t('linked_contact'),
        sortable: false,
        renderCell: ({ row }) => (
            <CellLink
                to={`${generatePathDatacentral(paths.customerDetail, {
                    id: String(row?.customer_id),
                })}?contact_id=${row?.customer_contact_id}`}
            >
                {row?.contact_name || row?.customer_name || row?.customer_id}
            </CellLink>
        ),
        width: 220,
    },
    {
        field: 'contact_roles',
        headerName: t('roles'),
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy>{row?.contact_roles?.join(', ') || '-'}</Typogaphy>
        ),
        width: 160,
    },
    // No linked-state column here: getResellerCandidates requests exclude_linked=true, so this tab
    // only ever receives contacts whose company has no reseller yet. A badge that always reads
    // "Chưa liên kết" would be noise, and the tab title already says it.
    {
        field: 'actions',
        headerName: t('actions'),
        sortable: false,
        renderCell: ({ row }) => (
            <Button
                variant="contained"
                onClick={() =>
                    navigate(paths.resellerCreate, {
                        state: {
                            customer_id: row.customer_id,
                            reseller_name:
                                row.customer_name || row.contact_name || '',
                        },
                    })
                }
            >
                {t('create_reseller')}
            </Button>
        ),
        width: 170,
    },
]
